import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export function getPolicy(state: ApplicationState, policy: string) {
    if (state.context.session.properties.securityPolicies) {
        return JSON.parse(state.context.session.properties.securityPolicies).includes(policy);
    }

    return false;
}
